(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2531],{

/***/ 79058:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plasmids/[setID]/[plasmidID]",
      function () {
        return __webpack_require__(84167);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: globalCommon  } = __webpack_require__(31668);
const { de: plasmidsCommon  } = __webpack_require__(91621);
module.exports = {
    ...globalCommon,
    ...plasmidsCommon,
    "plasmids-plasmid": __webpack_require__(29261),
    "section-try-for-free": __webpack_require__(3049)
};


/***/ }),

/***/ 64398:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: globalCommon  } = __webpack_require__(31668);
const { en: plasmidsCommon  } = __webpack_require__(91621);
module.exports = {
    ...globalCommon,
    ...plasmidsCommon,
    "plasmids-plasmid": __webpack_require__(62339),
    "section-try-for-free": __webpack_require__(33686)
};


/***/ }),

/***/ 33499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(64398),
    de: __webpack_require__(30411)
};


/***/ }),

/***/ 84167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _plasmidID_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/create-and-raise.js
var create_and_raise = __webpack_require__(55161);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/Html/index.js
var Html = __webpack_require__(73972);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/index.js + 2 modules
var DiPageHoC = __webpack_require__(74063);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithConditions/index.js
var WithConditions = __webpack_require__(83803);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/NextPageWithServices.js + 5 modules
var NextPageWithServices = __webpack_require__(18092);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Author.js



const HeroAuthor = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        className: "section-hero__author",
        ...props
    });
};
HeroAuthor.propTypes = {
    ...Paragraph/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var Author = (HeroAuthor);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Action.js
var Action = __webpack_require__(14593);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Grid = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/ButtonLink.js
var ButtonLink = __webpack_require__(85765);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Link.js
var Link = __webpack_require__(14594);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/VerticalDelimiter.js
var VerticalDelimiter = __webpack_require__(72498);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var atomic_react_Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/index.js + 1 modules
var Breadcrumbs = __webpack_require__(78086);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/Item.js
var Item = __webpack_require__(71125);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbarSearch/index.js + 1 modules
var PageNavbarSearch = __webpack_require__(59157);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbarSearch/Main.js
var Main = __webpack_require__(23069);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbarSearch/Sidebar.js
var Sidebar = __webpack_require__(68646);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js + 1 modules
var UList = __webpack_require__(51192);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var atomic_react_Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/Plasmids/ui/PageNavbarSearch/index.js
var ui_PageNavbarSearch = __webpack_require__(18570);
// EXTERNAL MODULE: ./src/Plasmids/ui/BlockAutocomplete/index.js + 4 modules
var BlockAutocomplete = __webpack_require__(87149);
// EXTERNAL MODULE: ./src/Plasmids/constants/index.js
var constants = __webpack_require__(77106);
// EXTERNAL MODULE: ./src/Plasmids/routes/index.js
var routes = __webpack_require__(27404);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hooks/useFormAction.js
var useFormAction = __webpack_require__(44993);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Alert/index.js
var Alert = __webpack_require__(3074);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/either/index.js + 1 modules
var either = __webpack_require__(71970);
;// CONCATENATED MODULE: ./src/Plasmids/providers/getPlasmidContentMap.js

/** @type {
	(setId: string, plasmidId: string) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }) => Promise<Right<string>>
} */ const getPlasmidContentMap = (setId, plasmidId)=>(param)=>{
        let { sgApiClient  } = param;
        return sgApiClient.getPlasmidContentMap(setId, plasmidId).then(either/* Right */.O6);
    };
/* harmony default export */ var providers_getPlasmidContentMap = (getPlasmidContentMap);

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidInteractiveMap/PlasmidInteractiveMap.js







const PlasmidInteractiveMap = (param)=>{
    let { setID , plasmidID , plasmidFilename  } = param;
    const { plasmidInteractiveMap  } = (0,DiPageHoC/* usePageData */.Vi)();
    const [loadPlasmidContentMap, { result  }] = (0,useFormAction/* default */.Z)(providers_getPlasmidContentMap);
    (0,react.useEffect)(()=>{
        loadPlasmidContentMap(setID, plasmidID);
        return ()=>{
        // refMapContainer.current = null;
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "viewport",
            id: "map-content",
            children: typeof plasmidInteractiveMap !== "undefined" && plasmidInteractiveMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "map1",
                className: "sg-map-placeholder",
                "data-relative-path": "".concat(setID, "/").concat(plasmidID),
                "data-filename": plasmidFilename,
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: result !== null && result !== void 0 ? result : plasmidInteractiveMap
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.ZP, {
                status: "error",
                title: "Something went wrong",
                className: "text-left mt-10",
                children: "Failed to fetch plasmid content map."
            })
        })
    });
};
PlasmidInteractiveMap.propTypes = {
    setID: prop_types.string,
    plasmidID: prop_types.string,
    plasmidFilename: prop_types.string
};
/* harmony default export */ var PlasmidInteractiveMap_PlasmidInteractiveMap = (PlasmidInteractiveMap);

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidInteractiveMap/index.js


;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidStaticMap/PlasmidStaticMap.js




const PlasmidStaticMap = (param)=>/*#__PURE__*/ {
    let { src , siteDomain  } = param;
    return (0,jsx_runtime.jsx)(Image/* default */.Z, {
        isBaseUrl: false,
        src: "https://".concat(siteDomain).concat(src)
    });
};
PlasmidStaticMap.propTypes = {
    src: prop_types.string.isRequired,
    siteDomain: prop_types.string.isRequired
};
/* harmony default export */ var PlasmidStaticMap_PlasmidStaticMap = (PlasmidStaticMap);

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidStaticMap/index.js


// EXTERNAL MODULE: ./src/Plasmids/ui/SectionCopyright/index.js + 1 modules
var SectionCopyright = __webpack_require__(30767);
// EXTERNAL MODULE: ./src/Plasmids/ui/SectionItems/index.js + 3 modules
var SectionItems = __webpack_require__(97703);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
;// CONCATENATED MODULE: ./src/Plasmids/providers/getPlasmidSequenceLineHeights.js
/* eslint-disable camelcase */ /** @type {
 	(setId: string, plasmidId: string, length: number) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }
) => import("../interfaces/ISGApiClient").Plasmid | null} */ const getPlasmidSequenceLineHeights = (setId, plasmidId, length)=>(param)=>{
        let { sgApiClient  } = param;
        return sgApiClient.getSequenceLineHeights(setId, plasmidId, length).then((data)=>{
            if (typeof data === "undefined") {
                return null;
            }
            const { filename , relative_path , line_count , est_line_height , last_line_heights , length: len  } = data;
            return {
                filename,
                relativePath: relative_path,
                lineCount: line_count,
                estLineHeight: est_line_height,
                lastLineHeights: last_line_heights,
                length: len
            };
        });
    };
/* harmony default export */ var providers_getPlasmidSequenceLineHeights = (getPlasmidSequenceLineHeights);

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidSequenceViewer/useSequenceLineHeight.js



/** @typedef SLHeightData
 * @property {string} filename
 * @property {string} relativePath
 * @property {number} lineCount
 * @property {number} estLineHeight
 * @property {number[]} lastLineHeights
 * @property {number} length
 */ /** @type {(setID: string, plasmidID: string, length: number) => SLHeightData | null} */ function useSequenceLineHeight(setID, plasmidID, length) {
    const [lineHeightData, setLineHeightData] = (0,react.useState)(null);
    const getSLLineHieght = (0,DiPageHoC/* useRun */.Sr)(providers_getPlasmidSequenceLineHeights);
    (0,react.useEffect)(()=>{
        if (length <= 0) return;
        getSLLineHieght(setID, plasmidID, length).then(setLineHeightData);
    }, [
        setID,
        plasmidID,
        length
    ]);
    return lineHeightData;
}
/* harmony default export */ var PlasmidSequenceViewer_useSequenceLineHeight = (useSequenceLineHeight);

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidSequenceViewer/SequenceLineContainer.js



const SequenceLineContainer = (param)=>/*#__PURE__*/ {
    let { scrollRef , overviewRef , filename , relativePath , lineCount , estLineHeight , lastLineHeights  } = param;
    return (0,jsx_runtime.jsx)("div", {
        id: "seq1",
        ref: scrollRef,
        className: "sg-visualization",
        "data-id": filename,
        "data-filename": filename,
        "data-relative-path": relativePath,
        "data-line-count": lineCount,
        "data-est-line-height": estLineHeight,
        "data-last-line-heights": "[".concat(lastLineHeights.join(","), "]"),
        "data-show-enzymes": "true",
        "data-show-features": "true",
        "data-show-primers": "true",
        "data-show-translations": "false",
        style: {
            height: "820px",
            width: "100%",
            borderStyle: "solid",
            borderWidth: "1px",
            overflowY: "scroll"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "viewport",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "overview",
                    ref: overviewRef
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tips"
                })
            ]
        })
    });
};
SequenceLineContainer.propTypes = {
    scrollRef: prop_types.object,
    overviewRef: prop_types.object,
    filename: prop_types.string,
    relativePath: prop_types.string,
    lineCount: prop_types.number,
    estLineHeight: prop_types.number,
    lastLineHeights: (0,prop_types.arrayOf)(prop_types.number)
};
/* harmony default export */ var PlasmidSequenceViewer_SequenceLineContainer = (SequenceLineContainer);

// EXTERNAL MODULE: ./src/Plasmids/utils/async-effects.js
var async_effects = __webpack_require__(79824);
;// CONCATENATED MODULE: ./src/Plasmids/utils/useHtmlElementInfo.js


/** @typedef HtmlElementInfo
 * @property {number} clientHeight
 * @property {number} clientWidth
 * @property {number} scrollTop
 * @property {number} scrollLeft
 * @property {number} scrollHeight
 * @property {number} scrollWidth
 */ /** @type {(ref: import("react").RefObject, deps?: any[]) => HtmlElementInfo} */ function useHtmlElementInfo(ref) {
    let deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const [info, setInfo] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (ref.current == null) return ()=>{};
        const updateInfo = (0,async_effects/* debounce */.Ds)(()=>{
            if (ref.current == null) return Promise.resolve();
            const { clientHeight , clientWidth , scrollTop , scrollLeft , scrollHeight , scrollWidth  } = ref.current;
            setInfo({
                clientHeight,
                clientWidth,
                scrollTop,
                scrollLeft,
                scrollHeight,
                scrollWidth
            });
            return Promise.resolve();
        }, 150);
        updateInfo();
        ref.current.addEventListener("scroll", updateInfo, {
            capture: false,
            passive: true
        });
        __webpack_require__.g.window.addEventListener("resize", updateInfo);
        return ()=>{
            if (ref.current != null) {
                ref.current.removeEventListener("scroll", updateInfo);
            }
            __webpack_require__.g.window.removeEventListener("resize", updateInfo);
        };
    }, [
        ref,
        ...deps
    ]);
    return info;
}
/* harmony default export */ var utils_useHtmlElementInfo = (useHtmlElementInfo);

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidSequenceViewer/useResizingEffect.js

function createPlaceholder(estLineHeight, lineNo) {
    const linePlaceholder = document.createElement("div");
    linePlaceholder.style.height = "".concat(estLineHeight, "px");
    linePlaceholder.id = "line-placeholder-".concat(lineNo);
    linePlaceholder.className = "line-placeholder";
    linePlaceholder.innerHTML = '<div class="line-placeholder-loader"></div>';
    linePlaceholder.dataset.lineNo = lineNo;
    return linePlaceholder;
}
function buildOverview(param, overview, start) {
    let { estLineHeight , lineCount  } = param;
    // eslint-disable-next-line no-param-reassign
    overview.innerHTML = "";
    let placeholder;
    Array.from({
        length: lineCount
    }).forEach((_, lineNo)=>{
        const linePlaceholder = createPlaceholder(estLineHeight, lineNo);
        if (start === lineNo) placeholder = linePlaceholder;
        overview.appendChild(linePlaceholder);
    });
    return placeholder;
}
function useResizingEffect(overviewRef, scrollRef, baseRef, lineHeightData) {
    (0,react.useEffect)(()=>{
        if (overviewRef.current == null || lineHeightData == null) {
            return;
        }
        const overview = overviewRef.current;
        const scroller = scrollRef.current;
        const start = Math.floor(baseRef.current / lineHeightData.length);
        const placeholder = buildOverview(lineHeightData, overview, start);
        if (placeholder) {
            scroller.scroll(0, placeholder.offsetTop - overview.offsetTop);
        }
    }, [
        lineHeightData,
        overviewRef.current,
        scrollRef.current
    ]);
}

;// CONCATENATED MODULE: ./src/Plasmids/utils/binary-search.js
/** @type {<T>(list: T[], direction: (item: T) => number, first?: number, length?: number) => T | undefined} */ const binarySearch = function(list, direction) {
    let first = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, length = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : list.length;
    if (length === 0) return undefined;
    if (length === 1) {
        if (direction(list[first]) === 0) return list[first];
        return undefined;
    }
    const middle = first + Math.floor(length / 2);
    const dir = direction(list[middle]);
    return(// prettier-ignore
    dir === 0 ? list[middle] : dir < 0 ? binarySearch(list, direction, first, middle - first) : binarySearch(list, direction, middle, first + length - middle));
};

;// CONCATENATED MODULE: ./src/Plasmids/utils/findFirstVisibleChild.js

/** @type {(scrollTop: number) => (element: HTMLElement) => number} */ const findVisible = (scrollTop)=>(element)=>{
        const parentTop = element.parentElement.offsetTop;
        const ownTop = element.offsetTop;
        const { scrollHeight  } = element;
        return Math.round((scrollTop - ownTop + parentTop) / scrollHeight);
    };
/** @type {(element: HTMLElement) => HTMLElement | undefined} */ const findFirstVisibleChild = (element, scrollTop)=>{
    const children = Array.from(element.childNodes);
    return binarySearch(children, findVisible(scrollTop));
};

;// CONCATENATED MODULE: ./src/Plasmids/utils/fromHtml.js
/** @type {(html: string) => HTMLElement} */ const fromHtml = (html)=>{
    const element = document.createElement("div");
    element.innerHTML = html;
    return element.firstChild;
};

;// CONCATENATED MODULE: ./src/Plasmids/providers/getPlasmidSequenceLineMap.js
/** @type {
 	(setId: string, plasmidId: string, length: number, base: number) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }) => Promise<string>
} */ const getPlasmidSequenceLine = (setId, plasmidId, length, base)=>(param)=>{
        let { sgApiClient  } = param;
        return sgApiClient.getSequenceLine(setId, plasmidId, length, base);
    };
/* harmony default export */ var getPlasmidSequenceLineMap = (getPlasmidSequenceLine);

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidSequenceViewer/useLinesCache.js



const lineId = (setID, plasmidID, lineLength, lineIndex)=>[
        setID,
        plasmidID,
        lineLength,
        lineIndex
    ].join("/");
function useLinesCache() {
    const linesCache = (0,react.useRef)(new Map());
    const getLineHtml = (0,DiPageHoC/* useRun */.Sr)(getPlasmidSequenceLineMap);
    return (0,react.useCallback)((setID, plasmidID, lineHeight, index)=>{
        const cache = linesCache.current;
        const id = lineId(setID, plasmidID, lineHeight, index);
        var ref;
        const htmlPromise = (ref = cache.get(id)) !== null && ref !== void 0 ? ref : getLineHtml(setID, plasmidID, lineHeight, index * lineHeight);
        if (!cache.has(id)) cache.set(id, htmlPromise);
        return htmlPromise;
    }, []);
}
/* harmony default export */ var PlasmidSequenceViewer_useLinesCache = (useLinesCache);

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidSequenceViewer/useScrollingEffect.js




function useScrollingEffect(setID, plasmidID, scrollRef, overviewRef, baseRef, containerInfo, scrollInfo, lineHeightData) {
    const getLineHtml = PlasmidSequenceViewer_useLinesCache();
    (0,react.useEffect)(()=>{
        if (lineHeightData == null || containerInfo == null || scrollRef.current == null || overviewRef.current == null) {
            return;
        }
        const overview = overviewRef.current;
        const { estLineHeight , length , lineCount  } = lineHeightData;
        const { clientHeight , scrollTop  } = scrollRef.current;
        const linesOnPage = Math.round(Math.floor(clientHeight / estLineHeight) + 1);
        const firstVisibleChild = findFirstVisibleChild(overview, scrollTop);
        if (firstVisibleChild == null) return;
        const firstVisibleLineNo = +firstVisibleChild.dataset.lineNo;
        baseRef.current = firstVisibleLineNo * length; // eslint-disable-line no-param-reassign
        const start = Math.max(0, firstVisibleLineNo - linesOnPage);
        const end = Math.min(lineCount - 1, firstVisibleLineNo + 2 * linesOnPage);
        Array.from({
            length: end - start + 1
        }).forEach((_, index)=>{
            const lineNo = start + index;
            const linePlaceholder = document.getElementById("line-placeholder-".concat(lineNo));
            if (linePlaceholder == null || linePlaceholder.loading) return;
            linePlaceholder.loading = true;
            getLineHtml(setID, plasmidID, length, lineNo).then((html)=>{
                if (linePlaceholder && overview.contains(linePlaceholder) && html) {
                    const line = fromHtml(html);
                    line.dataset.lineNo = lineNo;
                    overview.replaceChild(line, linePlaceholder);
                }
            });
        });
    }, [
        lineHeightData,
        containerInfo === null || containerInfo === void 0 ? void 0 : containerInfo.clientWidth,
        scrollInfo === null || scrollInfo === void 0 ? void 0 : scrollInfo.scrollTop
    ]);
}

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidSequenceViewer/getLineLength.js
/** @type {(width: number) => number} */ const getLineLength = (width)=>// prettier-ignore
    width < 560 ? 10 : width < 670 ? 20 : width < 770 ? 30 : width < 870 ? 40 : width < 970 ? 50 : width < 1070 ? 60 : width < 1170 ? 70 : 80;

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidSequenceViewer/PlasmidSequenceViewer.js
/* eslint-disable react/no-danger */ 









function PlasmidSequenceViewer(param) {
    let { setID , plasmidID  } = param;
    const containerRef = (0,react.useRef)(null);
    const scrollRef = (0,react.useRef)(null);
    const overviewRef = (0,react.useRef)(null);
    const baseRef = (0,react.useRef)(0);
    const containerInfo = utils_useHtmlElementInfo(containerRef);
    const lineLength = containerInfo != null ? getLineLength(containerInfo.clientWidth) : 0;
    const lineHeightData = PlasmidSequenceViewer_useSequenceLineHeight(setID, plasmidID, lineLength);
    const scrollInfo = utils_useHtmlElementInfo(scrollRef, [
        lineHeightData
    ]);
    useResizingEffect(overviewRef, scrollRef, baseRef, lineHeightData);
    useScrollingEffect(setID, plasmidID, scrollRef, overviewRef, baseRef, containerInfo, scrollInfo, lineHeightData);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        spacing: {
            my: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "sg-sequence-wrapper",
            style: {
                width: "100%"
            },
            ref: containerRef,
            children: lineHeightData && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlasmidSequenceViewer_SequenceLineContainer, {
                scrollRef: scrollRef,
                overviewRef: overviewRef,
                ...lineHeightData
            })
        })
    });
}
PlasmidSequenceViewer.propTypes = {
    setID: prop_types.string,
    plasmidID: prop_types.string,
    plasmidFilename: prop_types.string
};
/* harmony default export */ var PlasmidSequenceViewer_PlasmidSequenceViewer = (PlasmidSequenceViewer);

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidSequenceViewer/index.js


;// CONCATENATED MODULE: ./src/Plasmids/utils/plasmid/common.js
/* eslint-disable no-continue */ const handleClicks = false;
const convertToNumber = (value)=>{
    const parsed = typeof value === "string" ? parseFloat(value) : value;
    if (typeof parsed === "number" && !Number.isNaN(parsed)) {
        return parsed;
    }
    return null;
};
const getParentElement = (event)=>event.target.closest(".sg-visualization");
const getSvgParentElement = (event)=>event.target.closest("svg");
const getElementsByClasses = (classes)=>{
    const classNameArray = classes.split(" ");
    const elements = document.getElementsByClassName(classNameArray[0]);
    return [
        elements,
        classNameArray
    ];
};
const getAttrDataBase = (e)=>{
    const val = e.getAttribute("data-base");
    return convertToNumber(val, "data-base");
};
const getAttrDataId = (e)=>{
    const val = e.getAttribute("data-id");
    return convertToNumber(val, "data-id");
};
const getAttrDataSegment = (e)=>{
    const val = e.getAttribute("data-segment");
    return convertToNumber(val, "data-segment");
};
const getAttrDataClass = (e)=>e.getAttribute("class");
const getAttrDataLine = (e)=>{
    const val = e.getAttribute("data-line");
    return convertToNumber(val, "data-line");
};
const getAttrDataCutLocation = (e)=>{
    const val = e.getAttribute("data-cut-location");
    return convertToNumber(val, "data-cut-location");
};
// code to get offset {top,left} in document coordinates of any element.
// see http://javascript.info/tutorial/coordinates
const getOffsetRect = (elem)=>{
    const box = elem.getBoundingClientRect();
    const { body  } = document;
    const docElem = document.documentElement;
    const scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
    const scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
    const clientTop = docElem.clientTop || body.clientTop || 0;
    const clientLeft = docElem.clientLeft || body.clientLeft || 0;
    const top = box.top + scrollTop - clientTop;
    const left = box.left + scrollLeft - clientLeft;
    return {
        top: Math.round(top),
        left: Math.round(left)
    };
};
// Gets the computed style is a browser cross platform way
// call as follows:
// get_style(document.getElementById("container"), "border-radius");
const getStyle = (element, css3Prop)=>{
    let strValue = "";
    if (window.getComputedStyle) {
        strValue = getComputedStyle(element).getPropertyValue(css3Prop);
    } else if (element.currentStyle) {
        try {
            strValue = element.currentStyle[css3Prop];
        } catch (e) {
        // console.log(e);
        }
    }
    return strValue;
};
const findNearestRelativePositionParent = (element)=>{
    // check if we have relative position
    if (getStyle(element, "position") === "relative") {
        // found relative position
        return element;
    }
    // try parent
    if (element.parentNode == null) {
        return element;
    }
    if (element.parentNode.style != null) {
        return findNearestRelativePositionParent(element.parentNode);
    }
    return element;
};
const findSequenceLineNumber = (e)=>{
    // check if we have relative position
    const line = getAttrDataLine(e);
    if (line != null) return line;
    if (e.parentNode.style != null) return findSequenceLineNumber(e.parentNode);
    return null;
};
// Shows a tooltip in the correct position on an html page based on an SVG element.
//
// svgParentElement: svg element to base the position
// tipElement: tooltip to show
// over: an array of SVG elements to base the position.  The position will be the
//    outer extent of all the rectangles combined.
// showAbove: hint (true or false) to help with placement
// forEnzyme: rules for placement are slightly different for enzymes compared with
//    other elements.
//
const showTooltipByElement = (svgParentElement, tipElement, over, showAbove, forEnzyme)=>{
    const SHOW_ABOVE = !!(showAbove === "true" || showAbove === true);
    const FOR_ENZYME = typeof forEnzyme !== "undefined";
    const tooltipElement = tipElement;
    if (tooltipElement == null) return;
    const svgElements = tooltipElement.getElementsByTagName("svg");
    if (svgElements != null && svgElements.length !== 0) {
        const svgElement = svgElements[0];
        // The svg element <svg> needs a width and height of the actual calculated bounding
        // box which is hard to determine with the current code.  We will compute it here in
        // javascript and use it.
        if (svgElement.hasChildNodes()) {
            // const firstG = svgElement.childNodes[0];
            // const newElement = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            const svgElementSize = svgElement.getBBox();
            // set svg size slightly larger to avoid the content getting clipped
            const w = "".concat(svgElementSize.width + 10, "px");
            const h = "".concat(svgElementSize.height + 3, "px");
            svgElement.style.width = w;
            svgElement.style.height = h;
        }
    }
    // evil hack to force chrome to relayout the tooltip window.  Otherwise it "over-optimizes" the need
    // to do the layout.
    tooltipElement.style.display = "none";
    tooltipElement.style.display = "block";
    const viewport = svgParentElement.closest(".viewport");
    // const mapWidth = viewport.clientWidth;
    // const mapHeight = viewport.clientHeight;
    //    console.log("viewport="+mapWidth + " " + mapHeight);
    // figure out the offset in document coordinates of the svg element.  I can
    // compute the offset by computing the position in using
    const mapBb = svgParentElement.getBBox();
    mapBb.x = 0;
    mapBb.y = 0;
    const svgMapCTM = svgParentElement.getScreenCTM();
    const mapLeftPt = svgParentElement.createSVGPoint();
    const mapRightPt = svgParentElement.createSVGPoint();
    mapLeftPt.x = mapBb.x;
    mapLeftPt.y = mapBb.y;
    mapRightPt.x = mapBb.x + mapBb.width;
    mapRightPt.y = mapBb.y + mapBb.height;
    const mapLeftTransPt = mapLeftPt.matrixTransform(svgMapCTM);
    // const mapRightTransPt = mapRightPt.matrixTransform(svgMapCTM);
    // transform the bounding box from the bottom left and bottom right
    let x1 = 0;
    let y1 = 0;
    let x2 = 0;
    let y2 = 0;
    for(let i = 0; i < over.length; i += 1){
        const bb = over[i].getBBox();
        const overCTM = over[i].getScreenCTM(over[i]);
        const ptLeft = svgParentElement.createSVGPoint();
        const ptRight = svgParentElement.createSVGPoint();
        ptLeft.x = bb.x;
        ptLeft.y = bb.y;
        ptRight.x = bb.x + bb.width;
        ptRight.y = bb.y + bb.height;
        const toolLeftTransPt = ptLeft.matrixTransform(overCTM);
        const toolRightTransPt = ptRight.matrixTransform(overCTM);
        // add to results
        if (i === 0) {
            x1 = toolLeftTransPt.x - mapLeftTransPt.x;
            y1 = toolLeftTransPt.y - mapLeftTransPt.y;
            x2 = toolRightTransPt.x - mapLeftTransPt.x;
            y2 = toolRightTransPt.y - mapLeftTransPt.y;
        } else {
            x1 = Math.min(x1, toolLeftTransPt.x - mapLeftTransPt.x);
            y1 = Math.min(y1, toolLeftTransPt.y - mapLeftTransPt.y);
            x2 = Math.max(x2, toolRightTransPt.x - mapLeftTransPt.x);
            y2 = Math.max(y2, toolRightTransPt.y - mapLeftTransPt.y);
        }
    }
    const base = findNearestRelativePositionParent(svgParentElement);
    const baseRect = {
        left: 0,
        top: 0,
        width: base.clientWidth,
        height: base.clientHeight
    };
    if (base != null) {
        const baseOffsetRect = getOffsetRect(base);
        baseRect.left += baseOffsetRect.left;
        baseRect.top += baseOffsetRect.top;
    }
    const viewportRect = {
        left: 0,
        top: 0,
        width: viewport.clientWidth,
        height: viewport.clientHeight
    };
    {
        const viewportOffsetRect = getOffsetRect(viewport);
        viewportRect.left += viewportOffsetRect.left;
        viewportRect.top += viewportOffsetRect.top;
    }
    // transform hittest rectangle to base coordinates
    const hitRect = {
        left: x1,
        top: y1,
        width: x2 - x1,
        height: y2 - y1
    };
    {
        const svgOffsetRect = getOffsetRect(svgParentElement);
        hitRect.left += svgOffsetRect.left;
        hitRect.top += svgOffsetRect.top;
    }
    //
    // Placement logic begin
    // Now, everything is in base coordinates: hitRect, viewportRect.  We also have tipWidth and tipHeight.
    // The placement logic determines were to put the tooltip by setting tipRect.
    //
    const tipRect = {
        left: 0,
        top: 0,
        width: tooltipElement.getBoundingClientRect().width,
        height: tooltipElement.getBoundingClientRect().height
    };
    if (FOR_ENZYME) {
        // try to place in the upper right first --- if no room, go to upper left and shift down as necessary
        tipRect.left = hitRect.left + hitRect.width + 6;
        tipRect.top = hitRect.top - tipRect.height - 6;
        const roomRight = viewportRect.left + viewportRect.width > tipRect.left + tipRect.width;
        const roomUp = viewportRect.top < tipRect.top;
        if (roomUp && roomRight) {
        // it fits.  All done with placement.
        } else if (roomUp && !roomRight) {
            // no room to the right?  Slide left.
            tipRect.left = viewportRect.left + viewportRect.width - tipRect.width;
        } else if (!roomUp && roomRight) {
            // no room up, slide down
            tipRect.top = viewportRect.top;
        } else {
            // no room for either, place to the left and slide down
            tipRect.left = hitRect.left - tipRect.width - 6;
            tipRect.top = viewportRect.top;
        }
    } else {
        if (SHOW_ABOVE) {
            // try to place above
            tipRect.top = hitRect.top - tipRect.height - 6;
            if (tipRect.top < viewportRect.top) {
                // nevermind, too high.  Place below.
                tipRect.top = hitRect.top + hitRect.height + 6;
            }
        } else {
            // try to place below
            tipRect.top = hitRect.top + hitRect.height + 6;
            if (tipRect.top + tipRect.height > viewportRect.top + viewportRect.height) {
                // ok, do above then.
                tipRect.top = hitRect.top - tipRect.height - 6;
            }
        }
        // center horizontally
        tipRect.left = hitRect.left + hitRect.width / 2 - tipRect.width / 2;
        tipRect.left = Math.max(tipRect.left, viewportRect.left + 15);
        tipRect.left = Math.min(tipRect.left, viewportRect.left + viewportRect.width - tipRect.width - 15);
    }
    //
    // Placement logic end
    //
    // the final coordinates need to be base coordinates (closest relative parent).
    tipRect.left -= baseRect.left;
    tipRect.top -= baseRect.top;
    tooltipElement.style.left = "".concat(tipRect.left, "px");
    tooltipElement.style.top = "".concat(tipRect.top, "px");
    tooltipElement.style.visibility = "visible";
};
const hideTooltipByElement = (tool)=>{
    const element = tool;
    if (element != null) {
        element.style.visibility = "hidden";
    }
};
const hideTooltip = (tooltipId)=>{
    const tool = document.getElementById(tooltipId);
    if (tool != null) {
        hideTooltipByElement(tool);
    }
};

;// CONCATENATED MODULE: ./src/Plasmids/utils/plasmid/feature.js
/* eslint-disable no-continue */ 
const FEATURE_SEGMENT_ANY = 9999;
// select all DOM elements with the same class name, feature id and segmentIndex.  If
// the segement index or line number is -1, then ignore it.
const queryFeatureElements = (parentElement, classNames, featureId, segmentIndex, lineNumber)=>{
    const FEATURE_ID = convertToNumber(featureId);
    const SEGMENT_INDEX = convertToNumber(segmentIndex);
    const LINE_NUMBER = convertToNumber(lineNumber);
    // console.log(parentElement, classNames, FEATURE_ID, SEGMENT_INDEX, lineNumber);
    // break class names by spaces
    const [elements, classNameArray] = getElementsByClasses(classNames);
    const parentElements = parentElement.parentElement;
    const ret = [];
    for(let j = 0; j < elements.length; j += 1){
        const e = elements[j];
        // the element must be a child of the parent sg-visualization
        if (!parentElements.contains(e)) {
            continue;
        }
        // get the classes for this element and make sure we can find each of the classes
        // in the parameters in this.
        let missingClass = false;
        const c1 = getAttrDataClass(e);
        for(let k = 1; k < classNameArray.length; k += 1){
            if (c1.includes(classNameArray[k]) === false) {
                missingClass = true;
                break;
            }
        }
        if (missingClass) continue;
        // check for feature id match
        if (FEATURE_ID !== -1) {
            const id = getAttrDataId(e);
            if (id !== FEATURE_ID) continue;
        }
        // check for segment match
        if (SEGMENT_INDEX !== FEATURE_SEGMENT_ANY) {
            const segment = getAttrDataSegment(e);
            if (segment !== SEGMENT_INDEX) continue;
        }
        // check for line match
        if (LINE_NUMBER !== -1) {
            const line = findSequenceLineNumber(e);
            if (line !== LINE_NUMBER) continue;
        }
        ret.push(e);
    }
    return ret;
};

;// CONCATENATED MODULE: ./src/Plasmids/utils/plasmid/map-seq-interactivity.js
/* eslint-disable no-continue */ 

// const MAP_SEQ_INTERACTIVITY_CLIENT_VERSION = "2.1.2";
// const startup = function() {};
const showTooltip = (svgParentElement, tooltipId, boundingBoxId, showAbove)=>{
    const tipElement = document.getElementById(tooltipId);
    if (tipElement == null) {
        return;
    }
    const over = document.getElementById(boundingBoxId);
    if (over == null) {
        return;
    }
    showTooltipByElement(svgParentElement, tipElement, [
        over
    ], showAbove);
};
const brandingOver = (event)=>{
    const svgParentElement = getSvgParentElement(event);
    showTooltip(svgParentElement, "branding_tooltip", "branding_svg");
    document.getElementById("branding_svg_underline").style.opacity = 1.0;
    // set it as pointer and left it for the lifetime of the page
    document.getElementById("branding_svg").style.cursor = "pointer";
};
const brandingOut = ()=>{
    hideTooltip("branding_tooltip");
    document.getElementById("branding_svg_underline").style.opacity = 0.0;
};
const brandingUp = ()=>{
    const win = window.open("https://snapgene.com", "_blank");
    win.focus();
};
// shows, hides or toggles visibility for all elements of a specific class.
// Pass in the class name and either "visible", "hidden" or "toggle"
const setVisibility = (elements, command)=>{
    for(let j = 0; j < elements.length; j += 1){
        const element = elements[j];
        if (command === "visible") {
            element.style.visibility = "visible";
        } else if (command === "hidden") {
            element.style.visibility = "hidden";
        } else if (command === "toggle") {
            element.style.visibility = element.style.visibility === "hidden" ? "visible" : "hidden";
        }
    }
};
// select all DOM elements with the same class name, enzyme id and cut location
const queryEnzymeElements = (parentElement, classNames, enzymeId, cutLocation)=>{
    const ENZYME_ID = convertToNumber(enzymeId);
    const CUT_LOCATION = convertToNumber(cutLocation);
    // break class names by spaces
    const [elements, classNameArray] = getElementsByClasses(classNames);
    // filter by first class name
    const ret = [];
    for(let j = 0; j < elements.length; j += 1){
        const e = elements[j];
        // the element must be a child of the parent sg-visualization
        if (!parentElement.contains(e)) {
            continue;
        }
        // get the classes for this element and make sure we can find each of the classes
        // in the parameters in this.
        let skip = false;
        const c1 = getAttrDataClass(e);
        for(let k = 1; k < classNameArray.length; k += 1){
            if (c1.includes(classNameArray[k]) === false) {
                skip = true;
                break;
            }
        }
        if (!skip) {
            const id = getAttrDataId(e);
            const cut = getAttrDataCutLocation(e);
            if (id === ENZYME_ID && cut === CUT_LOCATION) {
                ret.push(e);
            }
        }
    }
    return ret;
};
// select all DOM elements with the same class name and enzyme id, but NOT
// the same cut location.
const querySimilarEnzymeElements = (parentElement, classNames, enzymeId, cutLocation)=>{
    const ENZYME_ID = convertToNumber(enzymeId);
    const CUT_LOCATION = convertToNumber(cutLocation);
    // break class names by spaces
    const [elements, classNameArray] = getElementsByClasses(classNames);
    const ret = [];
    for(let j = 0; j < elements.length; j += 1){
        const e = elements[j];
        // the element must be a child of the parent sg-visualization
        if (!parentElement.contains(e)) {
            continue;
        }
        // get the classes for this element and make sure we can find each of the classes
        // in the parameters in this.
        let skip = false;
        const c1 = getAttrDataClass(e);
        for(let k = 1; k < classNameArray.length; k += 1){
            if (c1.includes(classNameArray[k]) === false) {
                skip = true;
                break;
            }
        }
        if (!skip) {
            const id = getAttrDataId(e);
            const cut = getAttrDataCutLocation(e);
            if (id === ENZYME_ID && cut !== CUT_LOCATION) {
                ret.push(e);
            }
        }
    }
    return ret;
};
const enzymeOver = (event, enzymeId, cutLocation)=>{
    const parentElement = getParentElement(event);
    const svgParentElement = getSvgParentElement(event);
    // need to get the placement hint for the tooltip
    const sideHint = event.target.closest(".sg-hittest").getAttribute("data-side");
    const showAbove = sideHint === "top";
    // show the enzyme over elements, plus recognition sequence and cut indicator.  Show similar elements for
    // other enzymes related to this id/cut location.
    // the recogintion and cut indicator class names have changed over time  they have been
    // sg-enzyme-recognition-sequence
    // or
    // sg-enzyme sg-recognition-sequence
    setVisibility(queryEnzymeElements(parentElement, "sg-enzyme sg-over", enzymeId, cutLocation), "visible");
    setVisibility(queryEnzymeElements(parentElement, "sg-enzyme-recognition-sequence", enzymeId, cutLocation), "visible");
    setVisibility(queryEnzymeElements(parentElement, "sg-enzyme-cut-indicator", enzymeId, cutLocation), "visible");
    setVisibility(querySimilarEnzymeElements(parentElement, "sg-enzyme sg-similar", enzymeId, cutLocation), "visible");
    showTooltipByElement(svgParentElement, queryEnzymeElements(parentElement, "sg-enzyme sg-tooltip", enzymeId, cutLocation)[0], queryEnzymeElements(parentElement, "sg-enzyme sg-hittest", enzymeId, cutLocation), showAbove, true);
};
const enzymeOut = (event, enzymeId, cutLocation)=>{
    const parentElement = getParentElement(event);
    // hide everything related to this enzyme.
    setVisibility(queryEnzymeElements(parentElement, "sg-enzyme sg-over", enzymeId, cutLocation), "hidden");
    setVisibility(queryEnzymeElements(parentElement, "sg-enzyme-recognition-sequence", enzymeId, cutLocation), "hidden");
    setVisibility(queryEnzymeElements(parentElement, "sg-enzyme-cut-indicator", enzymeId, cutLocation), "hidden");
    setVisibility(querySimilarEnzymeElements(parentElement, "sg-enzyme sg-similar", enzymeId, cutLocation), "hidden");
    hideTooltipByElement(queryEnzymeElements(parentElement, "sg-enzyme sg-tooltip", enzymeId, cutLocation)[0]);
};
const enzymeClick = (event, enzymeId, cutLocation)=>{
    if (!handleClicks) return;
    const parentElement = getParentElement(event);
    // for testing we are allowing you to toggle the selected DOMs visibility this needs real logic for
    // this to be useful.
    setVisibility(queryEnzymeElements(parentElement, "sg-enzyme sg-selected", enzymeId, cutLocation), "toggle");
};
// select all DOM elements with the same class name, primer id and cut location
const queryPrimerElements = (parentElement, classNames, primerId, cutLocation)=>{
    const PRIMER_ID = convertToNumber(primerId);
    const CUT_LOCATION = convertToNumber(cutLocation);
    // break class names by spaces
    const [elements, classNameArray] = getElementsByClasses(classNames);
    const ret = [];
    for(let j = 0; j < elements.length; j += 1){
        const e = elements[j];
        // the element must be a child of the parent sg-visualization
        if (!parentElement.contains(e)) {
            continue;
        }
        // get the classes for this element and make sure we can find each of the classes
        // in the parameters in this.
        let skip = false;
        const c1 = getAttrDataClass(e);
        for(let k = 1; k < classNameArray.length; k += 1){
            if (c1.includes(classNameArray[k]) === false) {
                skip = true;
                break;
            }
        }
        if (!skip) {
            const id = getAttrDataId(e);
            const cut = getAttrDataCutLocation(e);
            if (id === PRIMER_ID && cut === CUT_LOCATION) {
                ret.push(e);
            }
        }
    }
    return ret;
};
// select all DOM elements with the same class name and primer id, but NOT
// the same cut location.
const querySimilarPrimerElements = (parentElement, classNames, primerId, cutLocation)=>{
    const PRIMER_ID = convertToNumber(primerId);
    const CUT_LOCATION = convertToNumber(cutLocation);
    // break class names by spaces
    const [elements, classNameArray] = getElementsByClasses(classNames);
    const ret = [];
    for(let j = 0; j < elements.length; j += 1){
        const e = elements[j];
        // the element must be a child of the parent sg-visualization
        if (!parentElement.contains(e)) {
            continue;
        }
        // get the classes for this element and make sure we can find each of the classes
        // in the parameters in this.
        let skip = false;
        const c1 = getAttrDataClass(e);
        for(let k = 1; k < classNameArray.length; k += 1){
            if (c1.includes(classNameArray[k]) === false) {
                skip = true;
                break;
            }
        }
        if (!skip) {
            const id = getAttrDataId(e);
            const cut = getAttrDataCutLocation(e);
            if (id === PRIMER_ID && cut !== CUT_LOCATION) {
                ret.push(e);
            }
        }
    }
    return ret;
};
const primerOver = (event, primerId, cutLocation)=>{
    const parentElement = getParentElement(event);
    const svgParentElement = getSvgParentElement(event);
    // need to get the placement hint for the tooltip
    const sideHint = event.target.closest(".sg-hittest").getAttribute("data-side");
    const showAbove = sideHint === "top";
    // show the primer over elements, plus recognition sequence and cut indicator.  Show similar elements for
    // other primers related to this id/cut location.
    setVisibility(queryPrimerElements(parentElement, "sg-primer sg-over", primerId, cutLocation), "visible");
    setVisibility(querySimilarPrimerElements(parentElement, "sg-primer sg-similar", primerId, cutLocation), "visible");
    showTooltipByElement(svgParentElement, queryPrimerElements(parentElement, "sg-primer sg-tooltip", primerId, cutLocation)[0], queryPrimerElements(parentElement, "sg-primer sg-hittest", primerId, cutLocation), showAbove);
};
const primerOut = (event, primerId, cutLocation)=>{
    const parentElement = getParentElement(event);
    // hide everything related to this primer.
    setVisibility(queryPrimerElements(parentElement, "sg-primer sg-over", primerId, cutLocation), "hidden");
    setVisibility(querySimilarPrimerElements(parentElement, "sg-primer sg-similar", primerId, cutLocation), "hidden");
    hideTooltipByElement(queryPrimerElements(parentElement, "sg-primer sg-tooltip", primerId, cutLocation)[0]);
};
const primerClick = (event, primerId, cutLocation)=>{
    if (!handleClicks) return;
    const parentElement = getParentElement(event);
    // for testing we are allowing you to toggle the selected DOMs visibility this needs real logic for
    // this to be useful.
    setVisibility(queryPrimerElements(parentElement, "sg-primer sg-selected", primerId, cutLocation), "toggle");
};
const featureOver = (event, featureId, segmentIndex, lineNumber)=>{
    const parentElement = getParentElement(event);
    const svgParentElement = getSvgParentElement(event);
    // need to get the placement hint for the tooltip
    const sideHint = event.target.closest(".sg-hittest").getAttribute("data-side");
    const showAbove = sideHint === "top";
    // show the feature over elements, plus recognition sequence and cut indicator.  Show similar elements for
    // other features related to this id/cut location.
    //
    // Note, we set the segment index to FEATURE_SEGMENT_ANY when searching for hittest regions because we want all the segments
    //   to be visible for the feature.
    setVisibility(queryFeatureElements(parentElement, "sg-feature sg-over", featureId, FEATURE_SEGMENT_ANY, -1), "visible");
    showTooltipByElement(svgParentElement, queryFeatureElements(parentElement, "sg-feature sg-tooltip", featureId, segmentIndex, -1)[0], queryFeatureElements(parentElement, "sg-feature sg-hittest", featureId, FEATURE_SEGMENT_ANY, lineNumber), showAbove);
};
const featureOut = (event, featureId, segmentIndex)=>{
    const parentElement = getParentElement(event);
    // hide everything related to this feature.
    setVisibility(queryFeatureElements(parentElement, "sg-feature sg-over", featureId, FEATURE_SEGMENT_ANY, -1), "hidden");
    hideTooltipByElement(queryFeatureElements(parentElement, "sg-feature sg-tooltip", featureId, segmentIndex, -1)[0]);
};
const featureClick = (event, featureId)=>{
    if (!handleClicks) return;
    const parentElement = getParentElement(event);
    // for testing we are allowing you to toggle the selected DOMs visibility this needs real logic for
    // this to be useful.
    setVisibility(queryFeatureElements(parentElement, "sg-feature sg-selected", featureId, FEATURE_SEGMENT_ANY, -1), "toggle");
}; /*
const orf_over = (event, orfId) => {
	const parentElement = getParentElement(event);
	const svgParentElement = getSvgParentElement(event);

	// show the orf over elements and tooltips
	setVisibility(queryOrfElements(parentElement, "sg-orf sg-over", orfId, -1), "visible");
	showTooltipByElement(
		svgParentElement,
		queryOrfElements(parentElement, "sg-orf sg-tooltip", orfId, -1)[0],
		queryOrfElements(parentElement, "sg-orf sg-hittest", orfId, -1),
	);
};

const orfOut = (event, orfId) => {
	const parentElement = getParentElement(event);

	// hide everything related to this orf.
	setVisibility(queryOrfElements(parentElement, "sg-orf sg-over", orfId, -1), "hidden");
	hideTooltipByElement(queryOrfElements(parentElement, "sg-orf sg-tooltip", orfId, -1)[0]);
};

const orfClick = (event, orfId) => {
	if (!handleClicks) return;

	const parentElement = getParentElement(event);

	// for testing we are allowing you to toggle the selected DOMs visibility this needs real logic for
	// this to be useful.
	setVisibility(queryOrfElements(parentElement, "sg-orf sg-selected", orfId, -1), "toggle");
};

const orfbOver = (event, orfId, centerBase, orfPosition, letterCode) => {
	const parentElement = getParentElement(event);
	const svgParentElement = getSvgParentElement(event);

	// find the text element
	const t = queryOrfElements(parentElement, "sg-orf sg-text", orfId, centerBase)[0];
	t.style.fontWeight = "700";

	// show the orf over elements and tooltips
	const tooltip = queryOrfElements(parentElement, "sg-orf sg-tooltip", orfId, -1)[0];

	let protien = "?";
	if (letterCode == "A") protien = "Alanine";
	if (letterCode == "B") protien = "Asparagine";
	if (letterCode == "C") protien = "Cysteine";
	if (letterCode == "D") protien = "Aspartic Acid";
	if (letterCode == "E") protien = "Glutamic Acid";

	if (letterCode == "F") protien = "Phenylalanine";
	if (letterCode == "G") protien = "Glycine";
	if (letterCode == "H") protien = "Histidine";
	if (letterCode == "I") protien = "Isoleucine";
	if (letterCode == "J") protien = "Leucine";

	if (letterCode == "K") protien = "Lysine";
	if (letterCode == "L") protien = "Leucine";
	if (letterCode == "M") protien = "Methionine";
	if (letterCode == "N") protien = "Asparagine";
	if (letterCode == "O") protien = "Pyrrolysine";

	if (letterCode == "P") protien = "Proline";
	if (letterCode == "Q") protien = "Glutamine";
	if (letterCode == "R") protien = "Arginine";
	if (letterCode == "S") protien = "Serine";
	if (letterCode == "T") protien = "Threonine";

	if (letterCode == "U") protien = "Selenocysteine";
	if (letterCode == "V") protien = "Valine";
	if (letterCode == "W") protien = "Tryptophan";
	if (letterCode == "X") protien = "Any";
	if (letterCode == "Y") protien = "Tyrosine";
	if (letterCode == "Z") protien = "Glutamine";

	// find the inner html, rip out everything before ORF and fill in with more parameters
	let s = tooltip.children[0].children[0].children[0].innerHTML;
	const pos = s.indexOf("ORF:");
	s = s.substr(pos);
	if (orfPosition == -1) {
		s = `Stop<br><br>${s}`;
	} else {
		s = `${protien} (${orfPosition})<br><br>${s}`;
	}
	tooltip.children[0].children[0].children[0].innerHTML = s;

	showTooltipByElement(
		svgParentElement,
		tooltip,
		queryOrfElements(parentElement, "sg-orf sg-text", orfId, centerBase),
		false,
	);
};

const orfbOut = (event, orfId, centerBase) => {
	const parentElement = getParentElement(event);

	const tooltip = queryOrfElements(parentElement, "sg-orf sg-tooltip", orfId, -1)[0];

	// hide everything related to this orf.
	hideTooltipByElement(tooltip);

	const t = queryOrfElements(parentElement, "sg-orf sg-text", orfId, centerBase)[0];
	t.style.fontWeight = "400";
};

const orfbClick = (event, orfId, centerBase) => {
	if (!handleClicks) return;

	const parentElement = getParentElement(event);

	// for testing we are allowing you to toggle the selected DOMs visibility this needs real logic for
	// this to be useful.
	//    setVisibility(query_orf_elements( "sg-orf sg-selected", orfId ), "toggle");
};
*/ 

;// CONCATENATED MODULE: ./src/Plasmids/utils/plasmid/orf.js
/* eslint-disable no-continue */ // select all DOM elements with the same class name, orf id

const queryOrfElements = (parentElement, classNames, orfId, orfBase)=>{
    const ORF_ID = convertToNumber(orfId);
    const ORF_BASE = convertToNumber(orfBase);
    // break class names by spaces
    const [elements, classNameArray] = getElementsByClasses(classNames);
    // filter by first class name
    const ret = [];
    for(let j = 0; j < elements.length; j += 1){
        const e = elements[j];
        // the element must be a child of the parent sg-visualization
        if (!parentElement.contains(e)) {
            continue;
        }
        // get the classes for this element and make sure we can find each of the classes
        // in the parameters in this.
        let missingClass = false;
        const c1 = getAttrDataClass(e);
        for(let k = 1; k < classNameArray.length; k += 1){
            if (c1.includes(classNameArray[k]) === false) {
                missingClass = true;
                break;
            }
        }
        if (missingClass) continue;
        if (ORF_ID !== -1) {
            const id = getAttrDataId(e);
            if (id !== ORF_ID) continue;
        }
        if (ORF_BASE !== -1) {
            const base = getAttrDataBase(e);
            if (base !== ORF_BASE) continue;
        }
        ret.push(e);
    }
    return ret;
};

;// CONCATENATED MODULE: ./src/Plasmids/utils/plasmid/ftrans.js


const ftransOver = (event, featureId, centerBase, letterPosition, letterCode)=>{
    const LETTER_POSITION = convertToNumber(letterPosition);
    const parentElement = getParentElement(event);
    const svgParentElement = getSvgParentElement(event);
    // find the ftrans tooltip -- there is only one for the visualization.  If is doesn't exist, create it now.
    let tooltip;
    const tooltipQuery = parentElement.querySelectorAll(".sg-ftrans.sg-tooltip")[0];
    // console.log('tooltipQuery', parentElement, tooltipQuery)
    if (tooltipQuery && tooltipQuery.length !== 0) {
        tooltip = tooltipQuery;
    } else {
        const tooltipText = '<table class="sg-ftrans sg-tooltip tooltip_table"><tbody><tr><td>text-goes-here</td></tr></tbody></table>';
        const collection = parentElement.querySelectorAll(".sg-tooltip-collection")[0];
        //   console.log('collection', collection)
        collection.insertAdjacentHTML("afterend", tooltipText);
        // eslint-disable-next-line prefer-destructuring
        tooltip = parentElement.querySelectorAll(".sg-ftrans.sg-tooltip")[0];
    }
    // console.log('tooltip', tooltip)
    // find the text element
    const t = queryOrfElements(parentElement, "sg-ftrans sg-text", featureId, centerBase)[0];
    t.style.fontWeight = "700";
    let protien = "Stop";
    if (letterCode === "A") protien = "Alanine";
    if (letterCode === "B") protien = "Asparagine";
    if (letterCode === "C") protien = "Cysteine";
    if (letterCode === "D") protien = "Aspartic Acid";
    if (letterCode === "E") protien = "Glutamic Acid";
    if (letterCode === "F") protien = "Phenylalanine";
    if (letterCode === "G") protien = "Glycine";
    if (letterCode === "H") protien = "Histidine";
    if (letterCode === "I") protien = "Isoleucine";
    if (letterCode === "J") protien = "Leucine";
    if (letterCode === "K") protien = "Lysine";
    if (letterCode === "L") protien = "Leucine";
    if (letterCode === "M") protien = "Methionine";
    if (letterCode === "N") protien = "Asparagine";
    if (letterCode === "O") protien = "Pyrrolysine";
    if (letterCode === "P") protien = "Proline";
    if (letterCode === "Q") protien = "Glutamine";
    if (letterCode === "R") protien = "Arginine";
    if (letterCode === "S") protien = "Serine";
    if (letterCode === "T") protien = "Threonine";
    if (letterCode === "U") protien = "Selenocysteine";
    if (letterCode === "V") protien = "Valine";
    if (letterCode === "W") protien = "Tryptophan";
    if (letterCode === "X") protien = "Any";
    if (letterCode === "Y") protien = "Tyrosine";
    if (letterCode === "Z") protien = "Glutamine";
    // find the inner html, rip out everything before ORF and fill in with more parameters
    /*       var s = tooltip.children[0].children[0].children[0].innerHTML;
           var pos = s.indexOf("ORF:");
           s = s.substr(pos);
           if (orf_position == -1) {
             s = "Stop<br><br>" + s;
           } else {
             s = protien + " (" + orf_position + ")<br><br>" + s;
           } */ let text = "";
    if (protien === "Stop" || LETTER_POSITION === 0) {
        text = protien;
    } else {
        text = "".concat(protien, " (").concat(letterPosition, ")");
    }
    // console.log('tooltip', tooltip)
    tooltip.children[0].children[0].children[0].innerHTML = text;
    showTooltipByElement(svgParentElement, tooltip, //        query_orf_elements( parentElement, "sg-ftrans sg-text", featureId, centerBase )[0],
    [
        event.target
    ], true);
};
const ftransOut = (event, featureId, centerBase)=>{
    const parentElement = getParentElement(event);
    const tooltip = parentElement.querySelectorAll(".sg-ftrans.sg-tooltip")[0];
    // hide everything related to this orf.
    hideTooltipByElement(tooltip);
    const t = queryOrfElements(parentElement, "sg-ftrans sg-text", featureId, centerBase)[0];
    t.style.fontWeight = "400";
};
const ftransClick = ()=>{};

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidsLegacyZone/initMapSeqInteractivity.js
/* eslint-disable camelcase, no-param-reassign */ 

function initMethods(target) {
    target.branding_over = brandingOver;
    target.branding_out = brandingOut;
    target.branding_up = brandingUp;
    target.enzyme_over = enzymeOver;
    target.enzyme_out = enzymeOut;
    target.enzyme_click = enzymeClick;
    target.feature_over = featureOver;
    target.feature_out = featureOut;
    target.feature_click = featureClick;
    target.primer_over = primerOver;
    target.primer_out = primerOut;
    target.ftrans_over = ftransOver;
    target.ftrans_out = ftransOut;
    target.ftrans_click = ftransClick;
    target.primer_click = primerClick;
/*	target.branding_out = branding_out;
		target.query_enzyme_elements = query_enzyme_elements;
		target.set_visibility = set_visibility;
		target.query_similar_enzyme_elements = query_similar_enzyme_elements;
		target.show_tooltip_by_element = show_tooltip_by_element;
		target.find_nearest_relative_position_parent = find_nearest_relative_position_parent;
		target.get_style = get_style;
		target.getOffsetRect = getOffsetRect;
		target.hide_tooltip_by_element = hide_tooltip_by_element;
		target.query_feature_elements = query_feature_elements;
		target.find_sequence_line_number = find_sequence_line_number; */ }
function initMapSeqInteractivity() {
    if (false) {}
    if (initMapSeqInteractivity.initialized) return;
    initMethods(__webpack_require__.g.document);
    initMethods(__webpack_require__.g.window);
    initMapSeqInteractivity.initialized = true;
}
initMapSeqInteractivity.initialized = false;
/* harmony default export */ var PlasmidsLegacyZone_initMapSeqInteractivity = (initMapSeqInteractivity);

;// CONCATENATED MODULE: ./src/Plasmids/ui/PlasmidsLegacyZone/index.js





const legacyStyles = "\nsvg.sg-map {\n	height: 100%;\n	width: 100%;\n}\n\n.tooltip_table {\n	max-width: 359px;\n	text-align: left;\n	position: absolute;\n	left: 0px;\n	top: 0px;\n	margin-left: auto;\n	margin-right: auto;\n	font: 11px Verdana, sans-serif !important;\n	background-color: #FAFEC6 !important;\n	border: 1px solid #A6A6A6;\n	box-shadow: 1px 1px 8px #AAA;\n	vertical-align: top;\n	visibility: hidden;\n	padding-top: 4px;\n	padding-left: 4px;\n	padding-right: 4px;\n	padding-bottom: 4px;\n	width: auto !important;\n	overflow: visible !important;\n}\n\n.tooltip_table .tooltip_recog svg {\n	display: block;\n	max-width: 100%;\n}\n\n.line-placeholder {\n	display: flex;\n	width: 100%;\n	align-items: center;\n	justify-content: center;\n}\n\n@keyframes placeHolderShimmer {\n	0% {\n		background-position: -800px 0\n	}\n	100% {\n		background-position: 800px 0\n	}\n}\n  \n.line-placeholder-loader {\n	animation-duration: 2s;\n	animation-fill-mode: forwards;\n	animation-iteration-count: infinite;\n	animation-name: placeHolderShimmer;\n	animation-timing-function: linear;\n	background-color: #E7E5E5;\n	background: linear-gradient(to right, #E7E5E5 0%, #F9F8F8 30%, #E7E5E5 60%);\n	background-size: 800px 17px;\n	height: 17px;\n	width: 70%;\n	position: relative;\n	border-radius: 6px;\n}\n";
function PlasmidLegacyZone(param) {
    let { children  } = param;
    PlasmidsLegacyZone_initMapSeqInteractivity();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
        sx: {
            textAlign: "center"
        },
        className: "container-map",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: legacyStyles
            }),
            children
        ]
    });
}
PlasmidLegacyZone.propTypes = {
    children: prop_types.node
};
/* harmony default export */ var PlasmidsLegacyZone = (PlasmidLegacyZone);

// EXTERNAL MODULE: ./node_modules/react-dom/client.js
var client = __webpack_require__(20745);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/di-context/context.js
var context = __webpack_require__(42202);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/di-context/Provider.js




const DiProvider = (param)=>{
    let { container , data , children  } = param;
    const run = (0,react.useCallback)((fn)=>fn(container, data, run), [
        container,
        data
    ]);
    return container != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
        value: {
            container,
            data,
            run
        },
        children: children
    }) : children;
};
DiProvider.propTypes = {
    container: prop_types.object,
    data: prop_types.object,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Provider = (DiProvider);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/Modals/Engine/context.js




const modalContext = /*#__PURE__*/ react.createContext({
    close: ()=>{}
});
const useModal = ()=>react.useContext(modalContext);
var _Component;
class ModalContext extends (_Component = react.Component) {
    static getDerivedStateFromError() {
        return {
            visible: false
        };
    }
    componentDidCatch(error) {
        this.handleError(error);
    }
    handleError(error) {
        const { onError  } = this.props;
        if (typeof onError === "function") onError(error);
    }
    render() {
        const { visible  } = this.state;
        const { children  } = this.props;
        if (!visible) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(modalContext.Provider, {
            value: {
                close: this.handleClose
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    ModalContext.Overlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContext.Overlay, {}),
                    children
                ]
            })
        });
    }
    constructor(props){
        super(props);
        (0,_define_property/* default */.Z)(this, "handleClose", (result)=>{
            const { onClose  } = this.props;
            this.setState((state)=>({
                    ...state,
                    visible: false
                }));
            if (typeof onClose === "function") onClose(result);
        });
        this.state = {
            visible: true
        };
    }
}
(0,_define_property/* default */.Z)(ModalContext, "Overlay", null);
ModalContext.propTypes = {
    onError: prop_types.func,
    onClose: prop_types.func,
    children: prop_types.node.isRequired
};

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/Modals/Engine/index.js






const render = (ModalComponent, props, container)=>new Promise((resolve, reject)=>{
        const node = document.createElement("div");
        document.body.appendChild(node);
        const onClose = (result)=>{
            document.body.removeChild(node);
            resolve(result);
        };
        const onError = (error)=>{
            document.body.removeChild(node);
            reject(error);
        };
        const root = (0,client.createRoot)(node);
        root.render(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContext, {
            onClose,
            onError,
            children: container ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
                container: container,
                data: props,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalComponent, {
                    ...props
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalComponent, {
                ...props
            })
        }));
    });

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Modal/Overlay.js




const ModalOverlay = (param)=>{
    let { className =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("modal__overlay", className)
    });
};
ModalOverlay.propTypes = {
    className: prop_types.string
};
/* harmony default export */ var Overlay = (ModalOverlay);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Modal/Modal.js






const Modal = (param)=>{
    let { size ="m" , className ="" , open =true , center =true , simple =false , overlay =false , children , forwardRef , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            overlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: forwardRef,
                tabIndex: "-1",
                className: (0,classes/* classes */.S)("modal", open && "modal--open", className),
                ...props,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,classes/* classes */.S)("modal__dialog", size && "modal__dialog-".concat(size), center && "modal__dialog--centered", simple && "modal__dialog--simple", className),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal__content",
                        children: children
                    })
                })
            })
        ]
    });
};
Modal.propTypes = {
    size: (0,prop_types.oneOf)([
        "s",
        "sm",
        "m",
        "l",
        "auto"
    ]),
    title: prop_types.string,
    className: prop_types.string,
    open: prop_types.bool,
    center: prop_types.bool,
    simple: prop_types.bool,
    overlay: prop_types.bool,
    children: prop_types.node.isRequired,
    forwardRef: forward_ref/* default */.Z
};
/* harmony default export */ var Modal_Modal = (Modal);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Modal/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Modal/Head.js




const ModalHead = (param)=>{
    let { className ="" , children =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("modal__header", className),
        children: children
    });
};
ModalHead.propTypes = {
    className: prop_types.string,
    children: prop_types.node
};
/* harmony default export */ var Head = (ModalHead);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Modal/Body.js




const ModalBody = (param)=>{
    let { className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("modal__body", className),
        children: children
    });
};
ModalBody.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Body = (ModalBody);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Modal/Close.js




const ModalClose = (param)=>{
    let { title ="Close" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        "aria-label": title,
        className: "modal__header-button-close",
        "data-dismiss": "modal",
        type: "button",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "times",
            size: "l"
        })
    });
};
ModalClose.propTypes = {
    title: prop_types.string
};
/* harmony default export */ var Close = (ModalClose);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hooks/useHotKey/keys.js
const KEY_ESCAPE = {
    key: "Escape"
};
const KEY_ALT = {
    altKey: true
};
const KEY_CTLR = {
    ctrlKey: true
};
const KEY_SHIFT = {
    shiftKey: true
};
const isKeyMatch = (keyPattern, event)=>Object.entries(keyPattern).every((param)=>{
        let [field, value] = param;
        return event[field] === value;
    });
const comb = function() {
    for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++){
        keys[_key] = arguments[_key];
    }
    return Object.assign({}, ...keys);
};

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hooks/useHotKey/hot-key-listener.js


const HotKeyListener = function() {
    let node = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : __webpack_require__.g.document, eventName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "keyup";
    const handlers = [];
    let isListening = false;
    const eventListener = (event)=>handlers.find((handler)=>handler(event));
    const updateListener = ()=>{
        if (node == null) return;
        if (handlers.length > 0 && !isListening) {
            node.addEventListener(eventName, eventListener);
            isListening = true;
        }
        if (handlers.length === 0 && isListening) {
            node.removeEventListener(eventName, eventListener);
            isListening = false;
        }
    };
    const remove = (callback)=>{
        const index = handlers.indexOf(callback);
        if (index < 0) return;
        handlers.splice(index, 1);
        updateListener();
    };
    const wrapCallback = (keyPattern, callback, once)=>{
        const wrapped = (event)=>{
            if (!isKeyMatch(keyPattern, event)) return false;
            callback(event);
            if (once) remove(wrapped);
            return true;
        };
        return wrapped;
    };
    const addHandler = (keyPattern, callback, once)=>{
        if (!(0,fn/* isFunc */.Wl)(callback)) return ()=>{};
        const handler = wrapCallback(keyPattern, callback, once);
        handlers.unshift(handler);
        updateListener();
        return ()=>remove(handler);
    };
    const clear = ()=>{
        handlers.splice(0, handlers.length);
        updateListener();
    };
    return {
        addHandler,
        clear
    };
};
/* harmony default export */ var hot_key_listener = (HotKeyListener);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hooks/useHotKey/index.js




const GLOBAL_LISTENER_ID = "IS/HOTKEY_LISTENER";
var _GLOBAL_LISTENER_ID;
__webpack_require__.g[GLOBAL_LISTENER_ID] = (_GLOBAL_LISTENER_ID = __webpack_require__.g[GLOBAL_LISTENER_ID]) !== null && _GLOBAL_LISTENER_ID !== void 0 ? _GLOBAL_LISTENER_ID : hot_key_listener();
const globalKeyListener = __webpack_require__.g[GLOBAL_LISTENER_ID];
function useHotKey(keyPattern, callback, dependencies) {
    const { key , altKey =false , ctrlKey =false , shiftKey =false  } = keyPattern;
    const handler = (0,react.useCallback)((event)=>(0,fn/* isFunc */.Wl)(callback) ? callback(event) : undefined, [
        key,
        altKey,
        ctrlKey,
        shiftKey,
        ...dependencies
    ]);
    (0,react.useEffect)(()=>globalKeyListener.addHandler(keyPattern, handler), [
        handler
    ]);
}
/* harmony default export */ var hooks_useHotKey = (useHotKey);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/Modals/ModalClose.js





const ModalClose_ModalClose = (param)=>{
    let { onClick , ...props } = param;
    hooks_useHotKey(KEY_ESCAPE, onClick, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {
        onClick: onClick,
        ...props
    });
};
ModalClose_ModalClose.propTypes = {
    onClick: prop_types.func
};

;// CONCATENATED MODULE: ./src/Plasmids/utils/browserDetect.js
const browserDetect = ()=>{
    const { userAgent  } = window.navigator;
    const browser = userAgent.indexOf("Opera") !== -1 || userAgent.indexOf("OPR") !== -1 ? "Opera" : userAgent.indexOf("Edg") !== -1 ? "Edge" : userAgent.indexOf("Chrome") !== -1 ? "Chrome" : userAgent.indexOf("Safari") !== -1 ? "Safari" : userAgent.indexOf("Firefox") !== -1 ? "Firefox" : userAgent.indexOf("MSIE") !== -1 || !!document.documentMode === true ? "IE" : "unknown";
    return browser;
};
/* harmony default export */ var utils_browserDetect = (browserDetect);

// EXTERNAL MODULE: ./src/Plasmids/utils/encodeURLFragment.js
var encodeURLFragment = __webpack_require__(20566);
;// CONCATENATED MODULE: ./src/Plasmids/domain/plasmid.js

const fileURL = (protocol, plasmidName, filePath)=>"".concat(protocol, "://") + "sequence?" + "source=url" + "&protocol=https" + "&name=".concat((0,encodeURLFragment/* encodeURLFragment */.Q)(plasmidName), "&path=").concat(filePath);

;// CONCATENATED MODULE: ./src/Plasmids/ui/OpenInSnapgeneModal/actions.js


//= ==============================================================
function openSequenceChrome(url) {
    const customLinkName = "temporaryAnchor";
    const existingLink = document.getElementById(customLinkName);
    if (existingLink) {
        existingLink.parentNode.removeChild(existingLink);
    }
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.innerHTML = customLinkName;
    anchor.setAttribute("id", customLinkName);
    anchor.setAttribute("style", "display:none;");
    anchor.setAttribute("target", "");
    document.body.appendChild(anchor);
    const createdLink = document.getElementById(customLinkName);
    if (createdLink === null || createdLink === undefined) return;
    let triggered = false;
    if (createdLink.dispatchEvent) {
        //   console.log("dispatching" + url);
        const event = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window
        });
        if (createdLink.dispatchEvent(event)) triggered = true;
    }
    if (!triggered && createdLink.click) {
        createdLink.click();
    }
}
//= ==============================================================
/*
function openSequenceMozilla(url) {
	const customFrameName = "temporaryFrame";
	const existingFrame = document.getElementById(customFrameName);
	if (existingFrame) {
		existingFrame.parentNode.removeChild(existingFrame);
	}
	const frame = document.createElement("iframe");
	frame.setAttribute("id", customFrameName);
	frame.setAttribute("style", "display:none;");
	frame.setAttribute("src", "about:blank");
	document.body.appendChild(frame);

	const createdFrame = document.getElementById(customFrameName);
	if (createdFrame === null || createdFrame === undefined) {
		return;
	}
	try {
		createdFrame.contentWindow.location.href = url;
	} catch (e) {
		// console.log(e);
	}
}
*/ const openSequence = (url)=>{
    const browser = utils_browserDetect();
    // protocolSupported = false;
    // Safari, Chrome, Opera 15+
    if (browser === "Safari" || browser === "Chrome" || browser === "Opera") {
        openSequenceChrome(url);
    } else if (browser === "Firefox") {
        openSequenceChrome(url);
    } else if (browser === "IE") {
        openSequenceChrome(url);
    } else if (browser === "Edge") {
        openSequenceChrome(url);
    } else {
    // console.log("[openSequence, browser]", browser);
    }
};
const setProtocol = (protocol, closeModal, props)=>{
    const { plasmidName , filePath  } = props;
    closeModal();
    const lastURL = fileURL(protocol, plasmidName, filePath);
    openSequence(lastURL);
};

;// CONCATENATED MODULE: ./src/Plasmids/ui/OpenInSnapgeneModal/index.js











 // TODO: brake the cycle imports

const OpenInSnapgeneModal = (param)=>{
    let { ...props } = param;
    const { close  } = useModal();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_Modal, {
        overlay: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalClose_ModalClose, {
                    onClick: ()=>close(false)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                        sx: {
                            textAlign: "center"
                        },
                        spacing: {
                            mt: 0,
                            mb: 6
                        },
                        children: "Please choose an application for opening sequence files."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
                        mx: true,
                        my: true,
                        utility: {
                            justify: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                sm: 12,
                                lg: 4,
                                sx: {
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    size: "s",
                                    onClick: ()=>setProtocol("snapgene", close, props),
                                    children: "Open with SnapGene"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                sm: 12,
                                lg: 4,
                                sx: {
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    styleType: "secondary",
                                    isOutline2: true,
                                    size: "s",
                                    onClick: ()=>setProtocol("snapgeneviewer", close, props),
                                    children: "Open with SnapGene Viewer"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                        utility: {
                            justify: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                            md: 8,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                                sx: {
                                    textAlign: "center"
                                },
                                spacing: {
                                    mt: 10
                                },
                                children: [
                                    "Don’t have either application?",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Link/* default */.Z, {
                                        href: routes/* ROUTE_FREE_TRIAL */.qd,
                                        children: "Download SnapGene"
                                    }),
                                    " or",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Link/* default */.Z, {
                                        href: routes/* ROUTE_SNAPGENE_VIEWER */.u,
                                        children: "SnapGene Viewer"
                                    }),
                                    "."
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_OpenInSnapgeneModal = (OpenInSnapgeneModal);

;// CONCATENATED MODULE: ./src/Plasmids/ui/OpenInSnapgeneModal/openInApp.js


// import { WithLocale } from "@insightfulscience/smart-react/i18";
 // TODO: brake the cycle imports
// import resources from "../../locales";
const openInApp = (plasmidName, filePath)=>{
    return render((0,pipe/* default */.Z)(ui_OpenInSnapgeneModal), {
        plasmidName,
        filePath
    });
};
/* harmony default export */ var OpenInSnapgeneModal_openInApp = (openInApp);

// EXTERNAL MODULE: ./src/Plasmids/utils/plasmid/helpers.js
var helpers = __webpack_require__(80702);
// EXTERNAL MODULE: ./src/Plasmids/services/sgApiConnection.js
var sgApiConnection = __webpack_require__(41674);
// EXTERNAL MODULE: ./src/Plasmids/services/sgApiClient.js + 3 modules
var sgApiClient = __webpack_require__(96373);
// EXTERNAL MODULE: ./src/Plasmids/services/index.js
var services = __webpack_require__(55093);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/props-resolver.js
var props_resolver = __webpack_require__(77915);
// EXTERNAL MODULE: ./src/Plasmids/providers/getPlasmidSequences.js
var getPlasmidSequences = __webpack_require__(12596);
;// CONCATENATED MODULE: ./src/Plasmids/providers/getPlasmid.js

/** @type {
	(setId: string, plasmidId: string) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }) => Promise<Right<import("../interfaces/ISGApiClient").Plasmid | null>>
} */ const getPlasmid = (setId, plasmidId)=>(param)=>{
        let { sgApiClient  } = param;
        return sgApiClient.getPlasmid(setId, plasmidId).then(either/* Right */.O6);
    };
/* harmony default export */ var providers_getPlasmid = (getPlasmid);

// EXTERNAL MODULE: ./src/Plasmids/providers/getPlasmidSets.js
var getPlasmidSets = __webpack_require__(31927);
;// CONCATENATED MODULE: ./src/Plasmids/providers/getPlasmidStaticMap.js

/** @type {
	(setId: string, plasmidId: string) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }) => Promise<Right<string>>
} */ const getPlasmidStaticMap = (setId, plasmidId)=>(param)=>{
        let { sgApiClient  } = param;
        return sgApiClient.getPlasmidStaticImage(setId, plasmidId).then(either/* Right */.O6);
    };
/* harmony default export */ var providers_getPlasmidStaticMap = (getPlasmidStaticMap);

;// CONCATENATED MODULE: ./src/Plasmids/resolvers/plasmid-resolvers.js








/* harmony default export */ var plasmid_resolvers = ((0,props_resolver/* default */.Z)({
    setSequencesData: (param, services)=>{
        let { query  } = param;
        return (0,getPlasmidSequences/* default */.Z)((0,encodeURLFragment/* encodeURLFragment */.Q)(query.setID))(services).then(either/* extRightStrict */.Gs);
    },
    getPlasmid: (param, services)=>{
        let { query  } = param;
        return providers_getPlasmid((0,encodeURLFragment/* encodeURLFragment */.Q)(query.setID), (0,encodeURLFragment/* encodeURLFragment */.Q)(query.plasmidID))(services).then(either/* extRightStrict */.Gs);
    },
    sets: getPlasmidSets/* default */.Z,
    plasmidStaticMap: (param, services)=>{
        let { query  } = param;
        return query.format ? providers_getPlasmidStaticMap((0,encodeURLFragment/* encodeURLFragment */.Q)(query.setID), (0,encodeURLFragment/* encodeURLFragment */.Q)(query.plasmidID))(services).then(either/* extRightStrict */.Gs) : "";
    },
    plasmidInteractiveMap: (param, services)=>{
        let { query  } = param;
        return providers_getPlasmidContentMap((0,encodeURLFragment/* encodeURLFragment */.Q)(query.setID), (0,encodeURLFragment/* encodeURLFragment */.Q)(query.plasmidID))(services).then(either/* extRightStrict */.Gs);
    }
}));

// EXTERNAL MODULE: ./src/AppError/index.js + 10 modules
var AppError = __webpack_require__(38209);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(3918);
// EXTERNAL MODULE: ./src/SectionTryForFree/index.js
var SectionTryForFree = __webpack_require__(98106);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
// EXTERNAL MODULE: ./locales/plasmids-plasmid-page/index.js
var plasmids_plasmid_page = __webpack_require__(33499);
var plasmids_plasmid_page_default = /*#__PURE__*/__webpack_require__.n(plasmids_plasmid_page);
;// CONCATENATED MODULE: ./pages/plasmids/[setID]/[plasmidID].js
/* eslint-disable react/prop-types */ 






















































const PlasmidsPlasmidPage = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("plasmids-plasmid");
    const siteDomain = config/* publicConfig.STATIC_SITE_DOMAIN */.mn.STATIC_SITE_DOMAIN;
    const { getPlasmid , sets =[] , setSequencesData ={} , plasmidStaticMap  } = (0,DiPageHoC/* usePageData */.Vi)();
    const { sequences  } = setSequencesData;
    const { setID , plasmidID , plasmidName , plasmidDesc , plasmidAuthor , plasmidFilename  } = getPlasmid;
    const set = sets.filter((item)=>item.set === setID)[0];
    const { plasmidSetName  } = set;
    const title = (0,helpers/* correctPlasmidName */.ev)(getPlasmid);
    const setTitle = plasmidSetName;
    const description = plasmidDesc;
    const author = plasmidAuthor;
    const filename = plasmidFilename;
    const filePath = "".concat(siteDomain, "/local/fetch.php?set=").concat(setID, "&plasmid=").concat(plasmidID);
    const downloadFile = (0,react.useCallback)(()=>{
        const fileAnchor = document.createElement("a");
        document.body.appendChild(fileAnchor);
        fileAnchor.href = "https://".concat(filePath);
        fileAnchor.click();
        document.body.removeChild(fileAnchor);
    }, [
        filePath
    ]);
    const route = (0,helpers/* routePlasmid */.uT)(setID, plasmidID);
    const url = "https://".concat(routes/* ROUTE_DOMAIN_PROD */.J$).concat(route);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        hero: true,
        isBorderBottomNone: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("META_TITLE", {
                    title
                }),
                description: description,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: t("META_TITLE", {
                            title
                        }),
                        description: description,
                        siteName: t("META_SITE_NAME"),
                        articlePublisher: t("META_ARTICLE_PUBLISHER"),
                        locale: t("META_LOCALE"),
                        type: t("META_TYPE"),
                        url: url,
                        image: t("META_IMAGE"),
                        imageSecureUrl: t("META_IMAGE_SECURE"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Author */.ZP.Author, {
                        content: t("META_AUTHOR")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        title: t("META_TITLE", {
                            title
                        }),
                        description: description,
                        card: t("META_TWITTER_CARD"),
                        creator: t("META_TWITTER_CREATOR"),
                        site: t("META_TWITTER_SITE"),
                        image: t("META_TWITTER_IMAGE"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Robots */.ZP.Robots, {
                        content: t("META_ROBOTS")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                        children: description
                    }),
                    author ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Author, {
                        children: [
                            t("SEQUENCE_AUTHOR"),
                            ": ",
                            author
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Action/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroRow */.P, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        size: "s",
                                        onClick: ()=>OpenInSnapgeneModal_openInApp(plasmidName, filePath),
                                        children: t("OPEN_IN_SNAPGENE")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        Component: ButtonLink/* default */.Z,
                                        href: routes/* ROUTE_FREE_TRIAL */.qd,
                                        styleType: "secondary",
                                        isOutline2: true,
                                        children: t("TRY_SNAPGENE_FOR_FREE")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroRow */.P, {
                        spacing: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroCol */.Z, {
                            sx: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Link/* default.Button */.Z.Button, {
                                    onClick: ()=>downloadFile(),
                                    target: "_blank",
                                    children: t("DOWNLOAD_PLASMID")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalDelimiter/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                    Component: Link/* default */.Z,
                                    href: routes/* ROUTE_SNAPGENE_VIEWER */.u,
                                    children: t("DOWNLOAD_SNAPGENE_VIEWER")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageNavbarSearch/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main/* default */.Z, {
                        children: [
                            "Explore Over ",
                            constants/* EXPLORE_OVER */.G8,
                            " Plasmids:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: ui_PageNavbarSearch/* PageNavbarSearchLink */.J,
                                href: (0,helpers/* routeSet */.nA)(setID),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                    Tag: "span",
                                    children: setTitle
                                })
                            }),
                            " ",
                            "|",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: ui_PageNavbarSearch/* PageNavbarSearchLink */.J,
                                href: routes/* ROUTE_PLASMIDS */.$b,
                                children: t("MORE_PLASMID_SETS")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAutocomplete/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                spacing: {
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Container */.W2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                            Component: Item/* BreadcrumbItemLink */.A,
                                            href: routes/* ROUTE_HOME */.XX,
                                            children: t("HOME")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                            Component: Item/* BreadcrumbItemLink */.A,
                                            href: routes/* ROUTE_PLASMIDS */.$b,
                                            children: t("PLASMIDS")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                            Component: Item/* BreadcrumbItemLink */.A,
                                            href: (0,helpers/* routeSet */.nA)(setID),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                Tag: "span",
                                                children: setTitle
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                        children: title
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default */.Z, {
                isBorderNone: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                            Tag: "div",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                href: plasmidStaticMap ? route : "".concat(route, "?format=png"),
                                children: plasmidStaticMap ? t("SHOW_INTERACTIVE_MAP") : t("SHOW_STATIC_MAP")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlasmidsLegacyZone, {
                            children: [
                                plasmidStaticMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PlasmidStaticMap_PlasmidStaticMap, {
                                    src: plasmidStaticMap,
                                    siteDomain: siteDomain,
                                    setID: setID,
                                    plasmidID: plasmidID
                                }, "static-image/".concat(setID, "/").concat(plasmidID)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PlasmidInteractiveMap_PlasmidInteractiveMap, {
                                    siteDomain: siteDomain,
                                    setID: setID,
                                    plasmidID: plasmidID,
                                    plasmidFilename: plasmidFilename
                                }, "interactive-image/".concat(setID, "/").concat(plasmidID)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlasmidSequenceViewer_PlasmidSequenceViewer, {
                                    setID: setID,
                                    plasmidID: plasmidID,
                                    plasmidFilename: plasmidFilename
                                }, "viewer/".concat(setID, "/").concat(plasmidID))
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
                isBorderNone: true,
                bgColor: "black--02",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        children: [
                            "Download ",
                            filename,
                            " file"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Col */.JX, {
                                    sm: 12,
                                    sx: {
                                        textAlign: "center"
                                    },
                                    spacing: {
                                        mt: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            spacing: {
                                                m: 3
                                            },
                                            size: "s",
                                            onClick: ()=>downloadFile(),
                                            children: t("DOWNLOAD_PLASMID")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            spacing: {
                                                m: 3
                                            },
                                            size: "s",
                                            styleType: "secondary",
                                            isOutline2: true,
                                            onClick: ()=>OpenInSnapgeneModal_openInApp(plasmidName, filePath),
                                            children: t("OPEN_IN_SNAPGENE")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
                                my: true,
                                mx: true,
                                utility: {
                                    justify: "center"
                                },
                                spacing: {
                                    mt: 7
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Col */.JX, {
                                        sm: 12,
                                        md: 11,
                                        lg: 5,
                                        spacing: {
                                            py: 5,
                                            px: 10
                                        },
                                        utility: {
                                            bgColor: "white",
                                            border: {
                                                width: 0
                                            }
                                        },
                                        className: "card-block",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                                                sx: {
                                                    fontSize: "xxl",
                                                    fontWeight: "normal",
                                                    fontColor: "black",
                                                    textAlign: "center"
                                                },
                                                utility: {
                                                    md: {
                                                        justify: "center"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: "/images/snapgene/plasmid-details/snapgene.png",
                                                        spacing: {
                                                            mr: 2
                                                        }
                                                    }),
                                                    "SnapGene"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                sx: {
                                                    fontSize: "l",
                                                    textAlign: "center"
                                                },
                                                children: "SnapGene is the easiest way to plan, visualize and document your everyday molecular biology procedures"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                                spacing: {
                                                    mb: 15
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                        children: "Fast accurate construct design for all major molecular cloning techniques"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                        children: "Validate sequenced constructs using powerful alignment tools"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                        children: "Customize plasmid maps with flexible annotation and visualization controls"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                        children: "Automatically generate a rich graphical history of every edit and procedure"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                                    sm: 12,
                                                    sx: {
                                                        textAlign: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Button/* default.Link */.Z.Link,
                                                        href: routes/* ROUTE_FREE_TRIAL */.qd,
                                                        className: "mt-3 width-100",
                                                        size: "s",
                                                        styleType: "secondary",
                                                        isOutline2: true,
                                                        children: t("DOWNLOAD_SNAPGENE")
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Col */.JX, {
                                        sm: 12,
                                        md: 11,
                                        lg: 5,
                                        spacing: {
                                            py: 5,
                                            px: 10
                                        },
                                        utility: {
                                            bgColor: "white",
                                            border: {
                                                width: 0
                                            }
                                        },
                                        className: "card-block",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                                                sx: {
                                                    fontSize: "xxl",
                                                    fontWeight: "normal",
                                                    fontColor: "black",
                                                    textAlign: "center"
                                                },
                                                utility: {
                                                    md: {
                                                        justify: "center"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: "/images/snapgene/plasmid-details/snapgene-viewer.png",
                                                        spacing: {
                                                            mr: 2
                                                        }
                                                    }),
                                                    t("SNAPGENE_VIEWER")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                sx: {
                                                    fontSize: "l",
                                                    textAlign: "center"
                                                },
                                                children: "SnapGene Viewer is free software that allows molecular biologists to create, browse, and share richly annotated sequence files."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                                spacing: {
                                                    mb: 27
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                        children: "Gain unparalleled visibility of your plasmids, DNA and protein sequences"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                        children: "Annotate features on your plasmids using the curated feature database"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                        children: "Store, search, and share your sequences, files and maps"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                                    sm: 12,
                                                    sx: {
                                                        textAlign: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Button/* default.Link */.Z.Link,
                                                        href: routes/* ROUTE_SNAPGENE_VIEWER */.u,
                                                        className: "mt-3 width-100",
                                                        size: "s",
                                                        styleType: "secondary",
                                                        isOutline2: true,
                                                        children: t("DOWNLOAD_SNAPGENE_VIEWER")
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionItems/* default */.Z, {
                type: "sequence",
                title: t("INDIVIDUAL_SEQUENCES_MAPS"),
                setID: setID,
                plasmidID: plasmidID,
                items: sequences
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionItems/* default */.Z, {
                type: "set",
                title: t("PLASMID_SETS"),
                setID: setID,
                items: sets
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionCopyright/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTryForFree/* default */.Z, {})
        ]
    });
};
PlasmidsPlasmidPage.getInitialProps = plasmid_resolvers;
PlasmidsPlasmidPage.services = {
    sgApiConn: (param)=>{
        let { sgApiConfig  } = param;
        return (0,sgApiConnection/* default */.Z)(__webpack_require__.g.fetch, sgApiConfig.baseUrl);
    },
    sgApiClient: (param)=>{
        let { sgApiConn  } = param;
        return (0,sgApiClient/* default */.Z)(sgApiConn);
    }
};
PlasmidsPlasmidPage.postConditions = [
    [
        (param)=>{
            let { getPlasmid  } = param;
            return !!getPlasmid;
        },
        (0,create_and_raise/* createAndRaise */.C)(ApplicationError/* default.NotFound */.Z.NotFound)
    ]
];
/* harmony default export */ var _plasmidID_ = ((0,pipe/* default */.Z)(PlasmidsPlasmidPage, (0,i18/* WithLocale */._t)({
    resources: (plasmids_plasmid_page_default())
}), WithConditions/* default */.ZP, (0,NextPageWithServices/* default */.Z)(services/* serviceCore */.T), AppError/* withErrorHandling */.b));


/***/ }),

/***/ 77106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bt": function() { return /* binding */ CORONAVIRUS_PAGE_ID; },
/* harmony export */   "G8": function() { return /* binding */ EXPLORE_OVER; }
/* harmony export */ });
/* unused harmony exports CLIENT_VERSION, PLASMID_FILE_EXT */
const CLIENT_VERSION = "2.1.2";
const PLASMID_FILE_EXT = ".dna";
const EXPLORE_OVER = "2.7k";
const CORONAVIRUS_PAGE_ID = "coronavirus_resources";


/***/ }),

/***/ 12596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71970);

/** @type {
	(setId: string, plasmidId: string) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }) => Promise<Right<Promise<import("../interfaces/ISGApiClient").PlasmidSequences>>
} */ const setSequencesData = (setId)=>(param)=>{
        let { sgApiClient  } = param;
        return sgApiClient.getSequences(setId).then(_insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_0__/* .Right */ .O6);
    };
/* harmony default export */ __webpack_exports__["Z"] = (setSequencesData);


/***/ }),

/***/ 30767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionCopyright_SectionCopyright; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
;// CONCATENATED MODULE: ./src/Plasmids/ui/SectionCopyright/SectionCopyright.js





const SectionCopyright = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default */.Z, {
        isBorderNone: true,
        spacing: {
            pt: 10,
            pb: 24
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    lg: 10,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                        sx: {
                            fontColor: "black--20",
                            textAlign: "center"
                        },
                        children: "The maps, notes, and annotations in the zip file on this page are copyrighted material. This material may be used without restriction by academic, nonprofit, and governmental entities, except that the source must be cited as ’’www.snapgene.com/resources’’. Commercial entities must contact GSL Biotech LLC for permission and terms of use."
                    })
                })
            })
        })
    });
/* harmony default export */ var SectionCopyright_SectionCopyright = (SectionCopyright);

;// CONCATENATED MODULE: ./src/Plasmids/ui/SectionCopyright/index.js



/***/ }),

/***/ 3074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports AlertRow, AlertLink */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42866);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74229);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25522);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2349);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7820);










const AlertRow = (param)=>/*#__PURE__*/ {
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_6__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_7__/* .spacingProps */ .tF
    } , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        sx: {
            fontSize: "m",
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(sx)
        },
        spacing: {
            my: 0,
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(spacing)
        },
        ...props,
        children: children
    });
};
AlertRow.propTypes = {
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_6__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_7__/* .spacingPropTypes */ .Xj,
    isLast: prop_types__WEBPACK_IMPORTED_MODULE_9__.bool,
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes
};
const AlertLink = (param)=>/*#__PURE__*/ {
    let { href , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        href: href,
        className: "alert__link",
        ...props,
        children: children
    });
};
AlertLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const Alert = (param)=>{
    let { title ="" , status ="success" , className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("alert", "alert--".concat(status), className),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                Tag: "h3",
                className: "alert__title",
                children: title
            }),
            children
        ]
    });
};
Alert.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_9__.node,
    status: (0,prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOf)([
        "default",
        "success",
        "error",
        "warning"
    ]),
    className: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node.isRequired
};
Alert.Row = AlertRow;
Alert.Link = AlertLink;
/* harmony default export */ __webpack_exports__["ZP"] = (Alert);


/***/ }),

/***/ 14593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36432);




const HeroAction = (param)=>/*#__PURE__*/ {
    let { center =true , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroRow */ .P, {
        center: center,
        className: "section-hero__action",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroCol */ .Z, {
            children: children
        })
    });
};
HeroAction.propTypes = {
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroAction);


/***/ }),

/***/ 85765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18774);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const HeroButtonLink = (param)=>{
    let { className ="" , size ="s" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Link */ .Z.Link, {
        size: size,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__button", className),
        ...props
    });
};
HeroButtonLink.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    size: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    ..._Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroButtonLink);


/***/ }),

/***/ 36432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ HeroRow; },
/* harmony export */   "Z": function() { return /* binding */ HeroCol; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);



const HeroCol = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: "shrink",
        ...props
    });
};
HeroCol.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes
};
const HeroRow = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        mx: true,
        my: true,
        center: true,
        ...props
    });
};
HeroRow.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row.propTypes */ .X2.propTypes
};


/***/ }),

/***/ 14594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);



const HeroLink = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "section-hero__link",
        ...props
    });
};
HeroLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroLink);


/***/ }),

/***/ 72498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74229);



const HeroVerticalDelimiter = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "span",
        className: "section-hero__vertical_delimiter",
        ...props,
        children: "|"
    });
};
HeroVerticalDelimiter.propTypes = {
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroVerticalDelimiter);


/***/ }),

/***/ 51192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UList_UList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UList/UList.js







const UListItem = (param)=>{
    let { bulletColor , size , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (0,classes/* classes */.S)("li", size && "text-".concat(size), bulletColor && "li--bullet-color-".concat(bulletColor), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
UListItem.propTypes = {
    size: props_sx/* fontSizePropTypes */.Gk,
    bulletColor: (0,prop_types.oneOf)([
        "orange",
        "dotmatics-7",
        "black--custom-1"
    ]),
    className: prop_types.string,
    children: prop_types.node.isRequired,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
const UList = (param)=>{
    let { type ="default" , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,classes/* classes */.S)("ul", "ul-".concat(type), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        children: children
    });
};
UList.propTypes = {
    type: (0,prop_types.oneOf)([
        "default",
        "pros",
        "cons"
    ]),
    className: prop_types.string,
    children: prop_types.node.isRequired,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
UList.Item = UListItem;
/* harmony default export */ var UList_UList = (UList);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js



/***/ }),

/***/ 29261:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"META_TITLE":"{{title}} Sequence and Map","META_ARTICLE_PUBLISHER":"https://www.facebook.com/SnapGene","META_AUTHOR":"GSL Biotech LLC","META_SITE_NAME":"SnapGene","META_LOCALE":"en_US","META_TYPE":"article","META_TWITTER_SITE":"@SnapGene","META_TWITTER_CARD":"summary_large_image","META_TWITTER_CREATOR":"@SnapGene","META_ROBOTS":"index,follow","SEQUENCE_AUTHOR":"Sequence Author"}');

/***/ }),

/***/ 62339:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"META_TITLE":"{{title}} Sequence and Map","META_ARTICLE_PUBLISHER":"https://www.facebook.com/SnapGene","META_AUTHOR":"GSL Biotech LLC","META_SITE_NAME":"SnapGene","META_LOCALE":"en_US","META_TYPE":"article","META_TWITTER_SITE":"@SnapGene","META_TWITTER_CARD":"summary_large_image","META_TWITTER_CREATOR":"@SnapGene","META_ROBOTS":"index,follow","SEQUENCE_AUTHOR":"Sequence Author"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,3308,2458,3918,4735,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(79058); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);